import type { ParsedBusiness } from "~/data/.server/business";

export function SafetySection(props: { business: ParsedBusiness }) {
  const { company, carrierInfo } = props.business;

  // Extract relevant data
  const safetyRating =
    company.safety_rating || carrierInfo?.detail?.safetyRating;
  const safetyRatingDate = carrierInfo?.detail?.safetyRatingDate;
  const allowedToOperate = carrierInfo?.detail?.allowedToOperate;
  const operatingStatus = carrierInfo?.detail?.statusCode;
  const safetyReviewDate = carrierInfo?.detail?.safetyReviewDate;
  const safetyReviewType = carrierInfo?.detail?.safetyReviewType;
  const oosDate = carrierInfo?.detail?.oosDate || carrierInfo?.oos?.oosDate;
  const oosReasonDescription = carrierInfo?.oos?.oosReasonDescription;
  const mcs150Outdated = carrierInfo?.detail?.mcs150Outdated;

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <div>
        <p>
          <span className="font-semibold">Safety Rating:</span>{" "}
          {safetyRating || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Safety Rating Date:</span>{" "}
          {safetyRatingDate || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Allowed to Operate:</span>{" "}
          {allowedToOperate || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Operating Status:</span>{" "}
          {operatingStatus || "N/A"}
        </p>
        <p>
          <span className="font-semibold">MCS-150 Outdated:</span>{" "}
          {mcs150Outdated || "N/A"}
        </p>
      </div>
      <div>
        <p>
          <span className="font-semibold">Safety Review Date:</span>{" "}
          {safetyReviewDate || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Safety Review Type:</span>{" "}
          {safetyReviewType || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Out-of-Service Date:</span>{" "}
          {oosDate || "N/A"}
        </p>
        <p>
          <span className="font-semibold">Out-of-Service Reason:</span>{" "}
          {oosReasonDescription || "N/A"}
        </p>
      </div>
    </div>
  );
}
